import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';
import { logOut } from '../features/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../images/logo.png';
import lcc_logo from '../images/lcc_logo_white.png';
import { WindowSharp } from '@mui/icons-material';

const TopBar = () => {
  const user = useSelector(state => state.auth.user)
  const dispatch = useDispatch()
  const location = useLocation()

  const handleLogout = async (e) => {
    dispatch(logOut())
  }

  var use_logo = logo
  var main_link = "/"


  if (location.pathname.includes("/register")) {
    return <></>
  }

  function redirectTo(url) {
    window.location.replace(url)
  }

  var barItems = [];
  if (process.env.REACT_APP_PREFIX.includes("lcc")) {
    use_logo = lcc_logo
    main_link = "https://leftcoastcabinets.com/"
    barItems.push(<Button key="main" color="inherit" onClick={() => redirectTo(main_link)}>
      <img src={use_logo} alt="Main page" style={{height: 48, borderRadius: 4}} />
    </Button>)
    if(user) {
      barItems.push(...[
        <Typography key="mainpage" variant="h6" component="div" sx={{ flexGrow: 0 }}>
        <Button component={Link} color="inherit" to={`/`}>Dashboard</Button>
        </Typography>
      ])
    }
    if (!user && location.pathname.includes("/purchaseorder")) {
      barItems.push(<Typography variant="h5" sx={{marginLeft: 3, marginRight: 3, fontWeight: "bold"}}>Purchase Order</Typography>)
    }
  } else {
   barItems.push(<Button key="main" component={Link} color="inherit" to={{pathname: main_link}}>
      <img src={use_logo} alt="Main page" style={{height: 48, width: 48, borderRadius: 4}} />
    </Button>)
  }
  if (!user) {
    barItems.push(
        <Box key="spacer" sx={{ flexGrow: 1 }}></Box>
    );
    barItems.push(
        <Button key="login" component={Link} color="inherit" to={`/login`}>Log in</Button>
    );
  } else {
    var usertype = "user"
    if(user.type) {
      usertype = user.type;
    }

    if (usertype === "user") {
      barItems.push(...[
        <Typography key="orders" variant="h6" component="div" sx={{ flexGrow: 0 }}>
          <Button component={Link} color="inherit" to={`/orders/`}>Orders</Button>
        </Typography>,
        <Typography key="products" variant="h6" component="div" sx={{ flexGrow: 0 }}>
          <Button component={Link} color="inherit" to={`/products/`}>Products</Button>
        </Typography>,
        <Typography key="designs" variant="h6" component="div" sx={{ flexGrow: 0 }}>
          <Button component={Link} color="inherit" to={`/designs/`}>Designs</Button>
        </Typography>,
        <Typography key="salesreps" variant="h6" component="div" sx={{ flexGrow: 0 }}>
          <Button component={Link} color="inherit" to={`/salesreps/`}>Sales Reps</Button>
        </Typography>,
      ])
      if (process.env.REACT_APP_PREFIX.includes("lcc")) {
        barItems.push(...[
          <Typography key="toolprofile" variant="h6" component="div" sx={{ flexGrow: 0 }}>
          <Button component={Link} color="inherit" to={`/toolprofiles/`}>Tool Profiles</Button>
          </Typography>,
          <Typography key="customitem" variant="h6" component="div" sx={{ flexGrow: 0 }}>
          <Button component={Link} color="inherit" to={`/customitems/`}>Custom Items</Button>
          </Typography>
        ])
      }
      if (user.permissions.includes("admin")) {
        barItems.push(
          <Typography key="persons" variant="h6" component="div" sx={{ flexGrow: 0 }}>
            <Button component={Link} color="inherit" to={`/persons/`}>People</Button>
          </Typography>
        )
      }
    } else if(usertype === "rep" || usertype === "finder") {
      barItems.push(
        <Typography key="commissions" variant="h6" component="div" sx={{ flexGrow: 0 }}>
        <Button component={Link} color="inherit" to={`/commissions/`}>Commissions</Button>
        </Typography>
      )
    }
    barItems.push(...[
      <Box key="spacer" sx={{ flexGrow: 1 }} alignItems="center" textAlign="center" />,
      <Typography key="username" variant="subtitle2">{user.full_name}</Typography>,
      <Button key="logout" color="inherit" onClick={handleLogout}>Log out</Button>
    ])
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          {barItems}
        </Toolbar>
      </AppBar>
    </Box>
    );

}

export default TopBar;
